import React, { useEffect } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, MenuItem } from '@mui/material';
import Grid from '@mui/system/Unstable_Grid';
import * as yup from 'yup';
import { useFormik } from 'formik';
const DialogDetalhes = ({ onClose, initial, valencias, ...props }) => {
    const formik = useFormik({
        initialValues: {
            valenciaId: undefined,
            parceiro: '',
            observacoes: '',
        },
        validationSchema: yup.object({
            valenciaId: yup.number()
                .transform((v, o) => (o === '' ? undefined : v)).required('O campo é obrigatório'),
            parceiro: yup.string().nullable(),
            observacoes: yup.string().nullable()
        }),
        validateOnMount: false,
        onSubmit: async (values) => {
            onClose({
                ...values,
                parceiro: values.parceiro?.trim() ? values.parceiro : undefined,
                observacoes: values.observacoes?.trim() ? values.observacoes : undefined,
            });
        }
    });
    // Formik fix dialog reuse
    useEffect(() => {
        formik.resetForm();
        formik.setValues({
            valenciaId: initial?.valenciaId,
            observacoes: initial?.observacoes,
            parceiro: initial?.parceiro
        });
    }, [initial]);
    return (<Dialog {...props}>
      <form>
        <DialogTitle>Editar detalhes</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Valência' name='valenciaId' value={formik.values?.valenciaId ?? ''} onChange={(e) => formik.setFieldValue('valenciaId', e.target.value === '' ? undefined : Number(e.target.value))} onBlur={formik.handleBlur} fullWidth error={formik.touched.valenciaId && Boolean(formik.errors.valenciaId)} helperText={formik.touched.valenciaId && formik.errors.valenciaId} required select>
                <MenuItem value='' disabled>
                  Escolha uma opção da lista
                </MenuItem>
                {valencias.map(x => (<MenuItem value={x.id} key={x.id}>
                    {x.categoria.designacao} - {x.designacao}
                  </MenuItem>))}
              </TextField>
            </Grid>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Parceiro' name='parceiro' value={formik.values?.parceiro ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.parceiro && Boolean(formik.errors.parceiro)} helperText={formik.touched.parceiro && formik.errors.parceiro}/>
            </Grid>
            <Grid lg={12} md={12} xs={12}>
              <TextField label='Observações' name='observacoes' value={formik.values?.observacoes ?? ''} onChange={formik.handleChange} onBlur={formik.handleBlur} fullWidth error={formik.touched.observacoes && Boolean(formik.errors.observacoes)} helperText={formik.touched.observacoes && formik.errors.observacoes}/>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button type='button' onClick={() => onClose(undefined)}>
            Cancelar
          </Button>
          <Button onClick={() => {
            formik.handleSubmit();
        }} disabled={!formik.isValid || !formik.dirty || formik.isSubmitting} variant='contained'>
            OK
          </Button>
        </DialogActions>
      </form>
    </Dialog>);
};
export default DialogDetalhes;
